export const BIOMETRIC_CHECK_REQUEST = 'BIOMETRIC_CHECK_REQUEST'
export const BIOMETRIC_AVAILABLE = 'BIOMETRIC_AVAILABLE'
export const BIOMETRIC_NOT_AVAILABLE = 'BIOMETRIC_NOT_AVAILABLE'
export const BIOMETRIC_LOGIN_REQUEST = 'BIOMETRIC_LOGIN_REQUEST'
export const BIOMETRIC_LOGIN_SUCCESS = 'BIOMETRIC_LOGIN_SUCCESS'
export const BIOMETRIC_LOGIN_FAIL = 'BIOMETRIC_LOGIN_FAIL'
export const BIOMETRIC_ENROLL_SUCCESS = 'BIOMETRIC_ENROLL_SUCCESS'
export const BIOMETRIC_ENROLL_FAIL = 'BIOMETRIC_ENROLL_FAIL'
